
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cleartax.in/webinars/[individualWebinar]",
      function () {
        return require("private-next-pages/cleartax.in/webinars/[individualWebinar].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cleartax.in/webinars/[individualWebinar]"])
      });
    }
  